import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaMagnifyingGlass } from "react-icons/fa6";
import TeamOverviews from "./index";
// import ViewTrainingOverview from "./view";
// import EditTrainingOverview from "./edit";
import { MODULE_TEAM_MENU } from "variables/modules";

const teamManagementRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Team Overview",
		basePath: "team-overview",
		mainComponent: <TeamOverviews />,
	    layout: "/console",	   
	    icon: <FaMagnifyingGlass className="icon-item" />,
	    subTitle:"Team Overview",
	    // viewComponent: <ViewTrainingOverview />,
	    // createComponent: <EditTrainingOverview />,
	    // editComponent: <EditTrainingOverview />,
		level:5,
		moduleId: MODULE_TEAM_MENU,
	})
]

export default teamManagementRoutes;